import React from 'react';
import { branch, renderComponent } from 'recompose';
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-flexbox-grid';
import logo from '../../img/loomis-logo.svg';

import './InviteUserError.scss'

const Error = ({error}) => {
    return (
        <div className="UnAuthorizedHeader">
            <div className="container">
                <Row>
                    <Col xs={12}>
                        <Row center="xs">
                            <Col xs={12} sm={6} md={4}>
                                <img className="login-logo" src={logo} alt="Loomis"/>
                                <div className="UnAuthorizedHeaderText">
                                    <h2>The supplied URL is not valid anymore!</h2>
                                    Please login from the <Link to="/login">Login page</Link>  or get a new invitation
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    )
};

export const withInviteUserError = branch(
    props => props.error,
    renderComponent(Error)
);



// WEBPACK FOOTER //
// ./src/components/invite/InviteUserError.js